<template>
    <SbsButtonIcon
        class="AudioPlayBtn"
        v-bind="playButtonData" />
</template>

<script>
export default {
    name: 'AudioPlayBtn',
    computed: {
        playButtonData() {
            return {
                height: '52',
                width: '52',
                iconName: this.isPlaying ? 'pause' : 'play',
                iconGroup: this.isPlaying ? 'solid' : 'duotone',
            };
        },
    },
    props: {
        isPlaying: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.AudioPlayBtn {
    background-color: $gray-ultra-light2;
    border-radius: 50%;

    &:hover {
        opacity: 0.8;
    }
}
</style>
